import { ThemedImage, RemansoFigure, EmotionFigure } from "@/components/Brand";
import { CHAPTERS, ACCOMPANY } from "@/lib/guide";

const ChapterArt = ({ art }) => {
  if (art === "isotipo") return <ThemedImage day="/brand/isotipo.svg" night="/brand/isotipo-noche.svg" alt="" style={{ height: 96, width: 91 }} />;
  if (art === "emociones") {
    return (
      <div className="flex gap-3" data-testid="chapter-emotions-row">
        {["alegria", "tristeza", "ira"].map((id) => <EmotionFigure key={id} id={id} height={76} />)}
      </div>
    );
  }
  return <RemansoFigure estado={art} height={96} />;
};

export const Chapter = ({ ch, index }) => (
  <section className="settle" data-testid={`story-chapter-${index}`}>
    <ChapterArt art={ch.art} />
    <p className="font-hand text-[24px] text-acento-texto mt-5">{ch.label}</p>
    <h3 className="font-serif text-[28px] leading-tight text-tinta mt-1">{ch.title}</h3>
    <div className="mt-3 space-y-3">
      {ch.paras.map((p) => <p key={p} className="font-sans text-[15px] text-sec leading-relaxed">{p}</p>)}
    </div>
  </section>
);

export const RemansoStory = () => (
  <div className="space-y-12" data-testid="remanso-story">
    {CHAPTERS.map((ch, i) => <Chapter key={ch.label} ch={ch} index={i} />)}
    <section data-testid="story-accompany">
      <h3 className="font-serif text-[24px] leading-tight text-tinta">Cómo te acompaña</h3>
      <div className="mt-4 space-y-3">
        {ACCOMPANY.map((a) => (
          <div key={a.estado} data-testid={`story-mode-${a.estado}`}
            className={`flex items-center gap-4 rounded-[24px] p-4 ${a.estado === "cuida" ? "bg-riesgo" : "bg-superficie"}`}>
            <RemansoFigure estado={a.estado} height={64} className="shrink-0" />
            <p className="text-[14px] text-tinta leading-relaxed"><span className="font-medium">{a.name}</span> · {a.text}</p>
          </div>
        ))}
      </div>
    </section>
    <p className="font-serif text-[20px] leading-snug text-tinta" data-testid="story-closing">
      Un Remanso nunca te dirá qué hacer, qué sientes ni quién eres.
    </p>
  </div>
);
